if (!customElements.get('cart-bonus')) {
    class CartBonus extends HTMLElement {

        constructor() {
            super();
            this.date = new Date(this.dataset.date || '');
            this.totalShipping = parseInt(this.dataset.totalShipping || '0') / 100;
            this.totalItems = parseInt(this.dataset.totalItems || '0') / 100;
            this.shippingCosts = this.dataset.shippingCosts;
            this.includeBonusDay = this.dataset.includeBonusDay == 'true';
            this.titleText = this.dataset.textTitle;
            this.textShipping = this.dataset.textShipping;
            this.textBonus = this.dataset.textBonus;
            this.titleWrapper = this.querySelector('[data-title]');
            this.textWrapper = this.querySelector('[data-text]');
            this.bonusAmount = 0;
            this.amountRemaining = 0;
            this.savingAmount = '';
        }

        connectedCallback() {
            try {
                this.tiers = JSON.parse(document.querySelector('[data-bonus-tiers]').innerText);
            } catch (e) {
                console.error(e);
            } finally {
                this.init();
            }
        }

        async init() {
            try {
                if (this.includeBonusDay && window.customer && !window.customer.currentUserNumber.startsWith('b2b_'))
                    await this.fetchBonusDay();

                this.tiers.sort((a, b) => a.threshold < b.threshold ? -1 : a.threshold > b.threshold ? 1 : 0);

                const { threshold } = this.shippingTier();

                if (this.totalShipping < threshold) {
                    this.calculateShippingBonus();
                    return;
                }

                this.calculate();

            } catch (e) {
                console.log("Unable to load bonus_day endpoint...", e);
            }
        }

        async fetchBonusDay() {

            if (window.customer.currentUserNumber.startsWith('b2b_')) {
                return;
            }

            const dateString = `${this.date.getDate() < 10 ? `0${this.date.getDate()}` : this.date.getDate()}${this.date.getMonth() + 1 < 10 ? `0${this.date.getMonth() + 1}` : this.date.getMonth() + 1}${this.date.getFullYear()}`;
            const storedResponse = localStorage.getItem(`${window.customer.currentUserNumber}_bonus_response`);

            if (storedResponse) {
                const { date, order_scale_determination_value, order_shipping_costs_value } = JSON.parse(storedResponse);
                if (dateString == date) {
                    this.totalItems += parseFloat(order_scale_determination_value);
                    this.totalShipping += parseFloat(order_shipping_costs_value);
                    return;
                }
            }

            const formData = new FormData();
            formData.set('customerId', window.customer.id || '');
            formData.set('userNumber', window.customer.currentUserNumber || '');
            formData.set('userName', window.customer.userName || '');
            formData.set('deliveryDate', dateString);

            const bonusRequest = await fetch('/apps/stroetmann/api/v1/users/bonus_day', {
                method: 'POST',
                body: formData
            });

            if (bonusRequest.ok) {

                const { bonus_day } = await bonusRequest.json();
                const { order_scale_determination_value, order_shipping_costs_value } = bonus_day[0];
                this.totalItems += parseFloat(order_scale_determination_value);
                this.totalShipping += parseFloat(order_shipping_costs_value);

                localStorage.setItem(`${window.customer.currentUserNumber}_bonus_response`, JSON.stringify({
                    date: dateString,
                    order_scale_determination_value: order_scale_determination_value,
                    order_shipping_costs_value: order_shipping_costs_value
                }));
            }
        }

        calculate() {

            const currentTier = this.currentTier();
            const nextTier = this.nextTier();

            if (!nextTier) {
                this.classList.add("hidden");
                return;
            }

            this.amountRemaining = (nextTier.threshold - this.totalItems);
            this.bonusAmount = (nextTier.threshold / 100 * nextTier.discount) - (this.totalItems / 100 * currentTier.discount);
            this.savingAmount = this.bonusAmount / this.amountRemaining * 100;

            const titleText = this.titleText
                .replaceAll('##AMOUNT_REMAINING##', window.formatMoney(this.amountRemaining * 100))
                .replaceAll('##PERCENT_SAVINGS##', this.savingAmount.toFixed(2));

            const bonusText = this.textBonus
                .replaceAll('##AMOUNT_REMAINING##', window.formatMoney(this.amountRemaining * 100))
                .replaceAll('##AMOUNT_SAVINGS##', window.formatMoney(this.bonusAmount * 100));

            this.render(titleText, bonusText);
        }

        calculateShippingBonus() {

            const { discount, threshold } = this.shippingTier();

            this.amountRemaining = (threshold - this.totalShipping);
            this.bonusAmount = this.shippingCosts;
            // this.savingAmount = (discount / 100) / this.amountRemaining * 100;
            this.savingAmount = this.shippingCosts / this.amountRemaining * 100;

            const titleText = this.titleText
                .replaceAll('##AMOUNT_REMAINING##', window.formatMoney(this.amountRemaining * 100))
                .replaceAll('##PERCENT_SAVINGS##', this.savingAmount.toFixed(2));

            const shippingText = this.textShipping
                .replaceAll('##AMOUNT_REMAINING##', window.formatMoney(this.amountRemaining * 100))
                .replaceAll('##AMOUNT_SAVINGS##', window.formatMoney(this.bonusAmount * 100));

            this.render(titleText, shippingText);
        }

        currentTier() {
            const tiers = this.tiers.filter(({ tier }) => tier != 'Shipping').filter(({ threshold }) => threshold < this.totalItems);
            return tiers[tiers.length - 1];
        }

        nextTier() {
            const tiers = this.tiers.filter(({ tier }) => tier != 'Shipping').filter(({ threshold }) => threshold > this.totalItems);
            return tiers[0];
        }

        shippingTier() {
            return this.tiers.find(({ tier }) => tier == 'Shipping');
        }

        render(title, text) {
            this.titleWrapper.innerHTML = title;
            this.textWrapper.innerHTML = text;
        }
    }

    customElements.define('cart-bonus', CartBonus);
}